// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "4affaf5",
    "hash": "4affaf5",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "4affaf5",
    "semverString": null,
    "version": "0.0.0"
};
/* tslint:enable */
